import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_cashbook_txn_stmt_recon_possible_link_RowClass
} from '../../../dbschema/index';

export class CashbookTxnStmtReconPossibleLinkContainer extends BaseContainerModel {
  bl_fi_cashbook_txn_stmt_recon_possible_link: bl_fi_cashbook_txn_stmt_recon_possible_link_RowClass = new bl_fi_cashbook_txn_stmt_recon_possible_link_RowClass();

}
